import { render, staticRenderFns } from "./SingleGameCombi.vue?vue&type=template&id=1e44200d"
import script from "./SingleGameCombi.vue?vue&type=script&lang=js"
export * from "./SingleGameCombi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports